import React, { useRef, useState, useEffect } from 'react';
import { View, Image, StyleSheet, ImageBackground, StatusBar, Dimensions, Text, Platform } from 'react-native';
import Animated, {
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';
import LottieView from "lottie-react-native";
import CircularProgress from 'react-native-circular-progress-indicator';
import { SharedTransition } from 'react-native-reanimated';

import { dispatch } from '../../../redux/store';
import { setFirstLaunch } from '../../../redux/auth/authSlice';
import AuthIcon from '../../../assets/Icons/AuthIcons'

const DURATION = 1000;
const DELAY = 1200;

const ImageSequence = ({ images }: { images?: any }) => {
  const [isShown, setShown] = useState(false);
  const opacities = images.map(() => useSharedValue(0));
  const animation = useRef(null);

  useEffect(() => {
    const show = () => {
      opacities.forEach((opacity: any, index: any) => {
        const targetOpacity = isShown ? 0 : 1;
        opacity.value = withDelay(index * DELAY, withTiming(targetOpacity, { duration: DURATION }));
      });

      setShown(!isShown);
    };

    const animationDuration = (images.length - 1) * (DURATION + DELAY);

    // Start animation when component mounts
    show();

    // Dispatch setFirstLaunch after animation completes
    const timer = setTimeout(() => {
      dispatch(setFirstLaunch());
    }, animationDuration);

    // Clean up timer
    return () => clearTimeout(timer);
  }, []);

  return (



    <View style={[styles.container]}>
      <StatusBar translucent backgroundColor={'transparent'} barStyle={'light-content'} />
      <View style={{position: 'absolute', zIndex: 99999, bottom: 20, right: 20}}>
        <CircularProgress
          activeStrokeWidth={8}
          inActiveStrokeWidth={8}
          initialValue={10}
          value={0}
          maxValue={10}
          radius={25}
          circleBackgroundColor={'transparent'}
          duration={10000}
          progressValueColor={'#ecf0f1'}
          activeStrokeColor={'#fff'}
          inActiveStrokeColor={'rgba(0,0,0,0.4)'}
        />
      </View>
      <View style={styles.text}>
        {images.map((image: any, index: any) => (
          <Animated.View
            key={index}
            style={{ ...styles.image, opacity: opacities[index] }}
          >
            {index === images.length - 1 ? (
              <ImageBackground source={image} style={styles.imageBackground}>
                {Platform.OS != 'web' ?
                  <LottieView
                    source={require("../../../assets/Lottie/lottie.json")}
                    style={{
                      width: "100%",
                      height: "100%",
                      // display:'flex',
                      // justifyContent:'center',
                      // alignItems:'center'
                    }}
                    autoPlay
                    loop
                    sharedTransitionTag="reanimatedTransition"
                  />

                  : <View style={{height:'100%',width:"100%",display:'flex',justifyContent:'center',alignItems:'center', transform: [{scale: 1.5}]}}>
                    <AuthIcon.LogoText />
                  </View>
                  }

              </ImageBackground>
            ) : (
              <Image source={image} style={styles.image} />
            )}
          </Animated.View>
        ))}
      </View>
    </View>
  );
};

export default ImageSequence;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
  imageBackground: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
});